import { Avatar } from "@mui/material";
import { useEffect, useState } from "react";

const MyPhoto = ({ profileImage, handleClick }, ref) => {
  const [photoUrl, setPhotoUrl] = useState(null);
  const fetchPhoto = async () => {
    try {
      const photoResponse = await fetch(
        "https://graph.microsoft.com/v1.0/me/photo/$value",
        {
          headers: {
            Authorization: localStorage.getItem("token")
          }
        }
      );

      if (photoResponse.status !== 200) {
        return;
      }

      const blob = await photoResponse.blob();
      setPhotoUrl(URL.createObjectURL(blob));
    } catch (error) {
      console.error("Error fetching profile photo", error);
    }
  };

  useEffect(() => {
    fetchPhoto();
  }, []);

  return (
    <Avatar
      className="profile-avatar"
      src={photoUrl ? photoUrl : (profileImage ? profileImage : "Assets/Avatar.png")}
      onClick={handleClick}
      sx={{
        cursor: "pointer",
        height: "2rem",
        width: "2rem",
      }}
    >
    </Avatar>
  );
};

export default MyPhoto;